export const messages = {
  en: {
    systemUser: {
      search: {
        title: 'Search Conditions',
        levelCd: 'Please select user role',
        nameLike: 'Please enter user name',
        tel: 'Please enter phone number'
      },
      list: {
        title: 'Property Users'
      },
      table: {
        userId: 'User ID',
        userName: 'User Name',
        tel: 'Phone',
        email: 'Email',
        address: 'Address',
        createTime: 'Create Time',
        levelCd: 'Role',
        ownerCount: 'Auth Count'
      },
      level: {
        admin: 'Admin',
        staff: 'Staff',
        user: 'User'
      },
      resetPwd: 'Reset Password',
      fetchError: 'Failed to fetch user list'
    }
  },
  zh: {
    systemUser: {
      search: {
        title: '查询条件',
        levelCd: '请选择人员角色',
        nameLike: '请输入用户名称',
        tel: '请输入手机号'
      },
      list: {
        title: '物业用户'
      },
      table: {
        userId: '用户编号',
        userName: '用户名称',
        tel: '手机号',
        email: 'Email',
        address: '地址',
        createTime: '创建时间',
        levelCd: '角色',
        ownerCount: '认证数'
      },
      level: {
        admin: '管理员',
        staff: '员工',
        user: '用户'
      },
      resetPwd: '重置密码',
      fetchError: '获取用户列表失败'
    }
  }
}